import posthog from 'posthog-js';

// Injected by webpack's DefinePlugin. Deliberately not read off `process.env`:
// webpack does not give the browser a `process` object, so a `process.env.X`
// read only works while DefinePlugin substitutes that exact expression — and
// the moment it does not, the reference throws `process is not defined` at the
// top of every page entry and takes the whole page's script down with it.
declare const __POSTHOG_KEY__: string;
declare const __POSTHOG_HOST__: string;

export function initPostHog(): void {
  // Analytics is never worth a broken page: every entry calls this at module
  // top level, so anything thrown here would abort the rest of the bundle.
  try {
    if (!__POSTHOG_KEY__) return;
    posthog.init(__POSTHOG_KEY__, {
      api_host: __POSTHOG_HOST__,
      person_profiles: 'identified_only',
    });
  } catch (err) {
    console.warn('[PostHog] init skipped:', err);
  }
}

export { posthog };
